import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  invoiceDetails: {
    marginBottom: 10,
  },

  titles: {
    height: 40,
    marginBottom: 24,
    justifyContent: 'space-between',
  },
  po: {
    color: colors.neutral,
    fontSize: 14,
    fontWeight: 600,
    height: 20,
  },

  mainTitle: {
    color: colors.neutral900,
    fontSize: 20,
    fontWeight: 700,
  },

  detailsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 80,
    marginVertical: 24,
  },

  detailsSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 80,
  },

  detailsTitle: {
    color: colors.neutral700,
    fontSize: 10,
    fontWeight: 700,
    marginBottom: 5,
    textTransform: 'uppercase',
  },

  text: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: '1.8px',
    color: colors.neutral900,
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
